import { Paper } from 'shared/ui/paper'
import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const SpecialToursCardSkeleton = () => {
  return (
    <Paper
      className={s.box}
      padding={[16, 0]}
    >
      <div className={s.header}>
        <Skeleton className={s.firstItem} />
        <Skeleton className={s.secondItem} />
      </div>

      <div className={s.tags}>
        <Skeleton className={s.tag} />
        <Skeleton className={s.tag} />
        <Skeleton className={s.tag} />
        <Skeleton className={s.tag} />
      </div>

      <div className={s.container}>
        <Skeleton className={s.firstBlock} />
        <Skeleton className={s.secondBlock} />
      </div>
    </Paper>
  )
}
